import { render } from "./AdvancedUploadField.vue?vue&type=template&id=cc126c6a&scoped=true"
import script from "./AdvancedUploadField.vue?vue&type=script&lang=js"
export * from "./AdvancedUploadField.vue?vue&type=script&lang=js"

import "./AdvancedUploadField.vue?vue&type=style&index=0&id=cc126c6a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc126c6a"]])

export default __exports__